"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = void 0;
class Language {
    /** @internal */
    constructor(options) {
        this.en = "";
        this.enNZ = "";
        this.de = "";
        this.setLanguages(options);
    }
    /** @internal */
    setLanguages(options) {
        this.en = (options === null || options === void 0 ? void 0 : options.en) || this.en;
        this.enNZ = (options === null || options === void 0 ? void 0 : options.enNZ) || this.enNZ;
        this.de = (options === null || options === void 0 ? void 0 : options.de) || this.de;
    }
    /**
     * If no options parameter is given we default to `en` as language
     * @param options
     */
    get(options) {
        if (!options) {
            return this.en;
        }
        const { language } = options;
        if (!this[language]) {
            console.error(`${language} not found`, this);
            return "";
        }
        return this[language];
    }
}
exports.Language = Language;
//# sourceMappingURL=Language.js.map